import { Provider } from '@angular/core';
import { LANGUAGE_REGION_TOKEN } from '@rx-applications/clientsite/shared/internationalization/utils';
import { InternationalizationService } from '../services';

export const LanguageRegionProvider: Provider = {
  provide: LANGUAGE_REGION_TOKEN,
  useFactory: (i18nService: InternationalizationService) => {
    const [language, region] = i18nService.getLocaleId().split('-');
    return {
      language,
      region: region ? region : language.toUpperCase()
    };
  },
  deps: [InternationalizationService],
}
